module.exports = __webpack_public_path__ + "static/background-image-s-2c5e1b0811c7f27ada8b2e1e827fe1e0.mp4";